<template>
  <div style="width:300px;height:100px;position:absolute;top:50px;margin-top:10px">
    <div class="step-line" :style="lintObjBack" />
    <div class="step-line" :style="lintObj" />
    <div class="step-tip">
      <div class="step-con">
        <p>解绑PID</p>
        <StepIcon :state="state >=0" :step="0" />
      </div>
      <div class="step-con">
        <p style="text-align:center">
          修改PID
        </p>
        <StepIcon :state="state >=1" :step="1" />
      </div>
      <div class="step-con">
        <p style="text-align:right">
          修改成功
        </p>
        <StepIcon :state="state >=2" :step="2" />
      </div>
    </div>
  </div>
</template>
<script>
import StepIcon from './icon';

const makeProcess = (state) => {
  switch (state) {
    case 0:
      return '0%';
    case 1:
      return '50%';
    case 2:
      return '100%';
    default: return '0%';
  }
};

export default {
  components: {
    StepIcon,
  },
  props: {
    state: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      lintObj: {
        width: makeProcess(this.state),
      },
      lintObjBack: {
        background: '#cccccc',
        width: '100%',
      },
    };
  },
};
</script>
<style lang="less" scoped>
.step-tip {
    width: 100%;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    height: 60px;
    .step-con {
        width:33%;

        text-align: center;
        position: relative;
        p {
          text-align: left;
        }
    }
}
.step-line {
    height: 1.5px;
    background: var(--ui-main-color);
    position: absolute;
    display: inline-block;
    top:45px;
    left:0%
}
</style>
